import { __assign } from "tslib";
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '@websky/core/src/theme';
import RootWarningModal from '@websky/core/src/WarningModal';
import Button from '@websky/core/src/Button';
import { isManualOperationError as getIsManualOperationError } from '../utils';
import css from './WarningModal.css';
var WarningModal = function (props) {
    var t = useTranslation('Refund').t;
    var theme = useTheme('Refund').Refund;
    var onReturnToOrder = React.useCallback(function () {
        props.handleReturnToOrder();
        props.onClose();
    }, [props.handleReturnToOrder, props.onClose]);
    var isManualOperationError = React.useMemo(function () {
        var _a;
        if (!props.error) {
            return false;
        }
        return getIsManualOperationError((_a = props.error['debugMessage']) !== null && _a !== void 0 ? _a : props.error['message']);
    }, [props.error]);
    var content = React.useMemo(function () {
        if (!isManualOperationError) {
            return props.content;
        }
        return (React.createElement("div", { className: css.content },
            React.createElement("div", { className: theme.warningModalContent, dangerouslySetInnerHTML: { __html: t('ManualOperationError') } }),
            React.createElement("div", { className: css.footer },
                React.createElement(Button, { className: cn(css.button, css.button_back), onClick: onReturnToOrder }, t('Back to order')),
                React.createElement(Button, { className: css.button, onClick: props.clearError }, t('Continue')))));
    }, [props.error, props.content, props.clearError, onReturnToOrder, isManualOperationError]);
    return (React.createElement(RootWarningModal, __assign({}, props, { content: content, buttonText: !isManualOperationError ? props.buttonText : null })));
};
export default WarningModal;
